<template>
  <div v-if="list">

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          color="amber"
          :complete="e1 > 1"
          :step="1"
          @click="e1 = 1"
          >Like</v-stepper-step
        >
        <v-divider></v-divider>

        <v-stepper-step
          color="amber"
          :complete="e1 > 2"
          :step="2"
          @click="e1 = 2"
          >Dislike</v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="1">
          <v-row>
            <v-col cols="6" class="mb-4">
              <h2 v-text="$t('exercise_keywords.step1.title')"></h2>
              <p
                v-for="(item, index) in $t(
                  'exercise_keywords.step1.description'
                )"
                :key="index"
                v-text="item"
              />
            </v-col>
          </v-row>

          <v-row dense class="mb-10">
            <template v-for="item in list">
              <v-col cols="3" :key="`like${item.id}`">
                <v-chip
                  class="ma-1 pl-3 pr-3 pt-6 pb-6"
                  :class="chipColor(item)"
                  @click="selectChip(item.id)"
                  :disabled="checkChip(item)"
                >
                  <span class="title font-weight-light">{{ item.title }} <span v-if="item.hint" class="body-2">({{item.hint}})</span></span>
                </v-chip>
              </v-col>
            </template>
          </v-row>

          <bottom-navigation
            :save="false"
            :next="true"
            :prev="false"
            :gridView="false"
            :gridToggle="false"
            @save="saveExercise"
            @prev="prevStep"
            @next="nextStep"
          >
            <p class="no-margin">
              <v-chip :class="likeClass">{{ likeCount }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content :step="2">
          <v-row>
            <v-col cols="6" class="mb-4">
              <h2 v-text="$t('exercise_keywords.step2.title')"></h2>
              <p
                v-for="(item, index) in $t(
                  'exercise_keywords.step2.description'
                )"
                :key="index"
                v-text="item"
              />
            </v-col>
          </v-row>

          <v-row dense class="mb-10">
            <template v-for="item in list">
              <v-col cols="3" :key="`dislike${item.id}`">
                <v-chip
                  class="ma-1 pl-3 pr-3 pt-6 pb-6"
                  :class="chipColor(item)"
                  @click="selectChip(item.id)"
                  :disabled="checkChip(item)"
                >
                  <span class="title font-weight-light">{{ item.title }} <span v-if="item.hint" class="body-2">({{item.hint}})</span></span>
                </v-chip>
              </v-col>
            </template>
          </v-row>

          <bottom-navigation
            :save="true"
            :next="false"
            :prev="true"
            :gridView="false"
            :gridToggle="false"
            @save="saveExercise"
            @prev="prevStep"
            @next="nextStep"
          >
            <p class="no-margin">
              <v-chip :class="dislikeClass">{{ dislikeCount }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title
          class="headline"
          v-text="$t('exercise_keywords.saved.title')"
        ></v-card-title>

        <v-card-text
          v-text="$t('exercise_keywords.saved.description')"
        ></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn
            color="amber accent-1"
            text
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
const fb = require("@/firebaseConfig.js");
export default {
  name: "UserKeywords",
  data() {
    return {
      list: [],
      like: [],
      dislike: [],
      likeLimit: 5,
      dislikeLimit: 5,
      e1: 1,
      dialog: false,
      exercise: null,
      componentReady: false,
      intervalId: null,
    };
  },
  components: {
    BottomNavigation,
  },
  watch: {
    exercise(val) {
      if (val) {
        this.mapLikes();
      }
    }
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    benchmarks() {
      return this.currentProjectModel.benchmarks;
    },
    benchmarksLength() {
      return this.currentProjectModel.benchmarks.length;
    },
    likes() {
      return this.list
        .filter((item) => item.selected === true)
        .filter((x) => x.like === true);
    },
    likeCount() {
      return this.list.filter((item) => item.like === true).length;
    },
    likeClass() {
      return this.likeCount > this.likeLimit ? "red" : "grey";
    },
    shortlist() {
      return this.list.filter((item) => item.selected === true);
    },
    dislikes() {
      return this.list
        .filter((item) => item.selected === true)
        .filter((x) => x.dislike === true);
    },
    dislikeCount() {
      let list = this.list.filter((item) => item.dislike === true);
      return list.length;
    },
    dislikeClass() {
      return this.likeCount > this.dislikeLimit ? "red" : "grey";
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getKeywords();
    },
    getKeywords() {
      let ref = fb.keywordsCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            items.map((item) => {
              item.selected = false;
              item.like = false;
              item.dislike = false;
            });
            this.list = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    selectChip(id) {
      let vm = this;
      let item = this.list.find((item) => item.id === id);
      let indexOfItem = this.list.indexOf(item);
      item.selected = !item.selected;
      if (this.e1 === 1) {
        item.like = !item.like;
      } else {
        item.dislike = !item.dislike;
      }
      vm.$set(vm.list, indexOfItem, item);
    },
    checkChip(chip) {
      if (this.e1 === 1) {
        return chip.dislike ? true : false;
      } else {
        return chip.like ? true : false;
      }
    },
    chipColor(chip) {
      if (chip.like) {
        return "lime black--text";
      } else if (chip.dislike) {
        return "red black--text";
      } else {
        return "";
      }
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.keywordsExCollection
        .where("uid", "==", `${this.currentUser.uid}`)
        .where("pid", "==", this.currentProjectModel.id);
      ref
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          if (items.length) {
            this.exercise = items[0];
            this.mapLikes();
            // this.list = l;
            // this.likes = this.exercise.like;
            // this.dislikes = this.exercise.dislike;
          }
        })
        .catch((error) => {
          console.log("no document", error);
        });
    },
    mapLikes() {
        this.list.forEach(item => {
              if (this.exercise.like.some(x => x.id == item.id )) {
                item.selected = true
                item.like = true
              }
              if (this.exercise.dislike.some(x => x.id == item.id )) {
                item.selected = true
                item.dislike = true
              }
            })
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = fb.keywordsExCollection.doc();
      } else {
        ref = fb.keywordsExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
          like: this.likes,
          dislike: this.dislikes,
          list: this.shortlist,
        })
        .then(() => {
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
